<template>
    <div class="new_navigation" >
        <v-navigation-drawer
            v-model="drawer"
            fixed
            clipped
            :class="drawer ? 'drawer-expanded' : 'drawer-close'"
            app
            v-if="getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline'|| getUserType()=='Booking_office'|| getUserType()=='CounterPrinter'">
            <v-list dense class="white new_navigation__container--drawer">
                <template v-if="getUserType() == 'Booking_office'">

                </template>

                <template v-else-if="getUserType() == 'CounterPrinter'">

                </template>

                <template v-else>
                    <template v-for="(item, i) in menuItems" >
                        <v-subheader v-if="item.section_title" :key="item.section_title" class="new_navigation__toolbar_options--section_header"
                         :style="{backgroundColor: item.header_color}">{{ item.section_title }}</v-subheader>
                        <v-list-group
                          sub-group
                          v-if="item.dropdown"
                          :key="i"
                          v-model="item.selected"
                          :class="{ 'new_navigation__toolbar_options--inactive_simple_item' : !item.active }">
                            <template v-slot:activator>
                                <v-list-tile-action class="new_navigation__toolbar_options--item_icon">
                                    <component :is="item.component"></component>
                                </v-list-tile-action>
                                <v-list-tile :title="item.title" class="new_navigation__toolbar_options--item_title">
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile>
                                <div class="v-list__group__header__append-icon">
                                    <i aria-hidden="true" class="v-icon material-icons theme--light">keyboard_arrow_down</i>
                                </div>
                            </template>
                            <v-list-tile v-for="(subItem, i) in item.sub_items" :key="i"
                             class="new_navigation__toolbar_options--dropdown_item" @click="changeRoute(subItem, subItem.route)"
                             :class="[{ 'new_navigation__toolbar_options--item_selected' : subItem.selected }, { 'new_navigation__toolbar_options--inactive_simple_item' : item.active && !subItem.active }]">
                                <v-list-tile-content :title="subItem.title">
                                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list-group>
                        <v-list v-else :key="item" class="new_navigation__toolbar_options--simple_item" :class="{ 'new_navigation__toolbar_options--inactive_simple_item' : !item.active }">
                            <v-list-tile @click="changeRoute(item, item.route)" :class="{ 'new_navigation__toolbar_options--item_selected' : item.selected }" :title="item.title">
                                <v-list-tile-action class="new_navigation__toolbar_options--item_icon">
                                    <component :is="item.component"></component>
                                </v-list-tile-action>

                                <v-list-tile>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list-tile>
                        </v-list>
                    </template>
                </template>
            </v-list>
            <p class="new_navigation__version">v {{ appVersion }}</p>
        </v-navigation-drawer>

        <v-toolbar
            color="white"
            app
            fixed
            clipped-left
        >
            <div class="new_navigation__container--toolbar">
                <div class="new_navigation__toolbar_options--menu">
                    <img
                    @click="drawer = !drawer"
                    src="../../assets/img/menu.svg"
                    class="new_navigation__container--toggle"
                    >
                    <span
                    class="title ml-3 mr-5 new_navigation__text--title"
                    >
                    <img
                        v-if="this.getCompany().personalize.app_logo != '' && this.getCompany().personalize.app_logo != null && this.getCompany().personalize.app_logo != undefined "
                        @click="drawer = !drawer"
                        style="max-width: 188px"
                        :src="this.getCompany().personalize.app_logo.url"
                    >
                    <img
                        v-else
                        @click="drawer = !drawer"
                        style="max-width: 188px"
                        src="../../assets/img/logo.png"
                    >
                    </span>
                </div>
                <v-hover>
                <v-toolbar-items>
                <v-menu>
                    <template v-slot:activator="{ on }">
                    <div
                        class="toolbar_dropdown"
                        v-on="on"
                    >
                        <v-flex>
                        <div>
                            Hola, <span class="toolbar_dropdown--title">
                            {{ getDisplayUserName() }}
                            </span>
                        </div>
                        <label class="toolbar_dropdown--email">
                            {{ getEmailUser() }}
                        </label>
                        </v-flex>
                        <img src="../../assets/img/arrow-down.svg" class="toolbar_dropdown--icon">
                    </div>
                    </template>
                    <v-list>
                    <v-list-tile @click="logout()">
                        <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
                    </v-list-tile>
                    </v-list>
                </v-menu>
                </v-toolbar-items>
                </v-hover>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
import user from './navigation/User'
import offline from 'v-offline';
import NavigationOption from './OptionNavigationDrawer.vue'

    export default {
        data: () => ({
            drawer: true,
            selected_item:'',
            selected_subitem:'',
            current_name:'Dashboard',
            charged: false,
            items: [],
        }),
        props: {

        },
        computed: {
            appVersion() {
                return process.env.APP_VERSION || 'dev'
            },
            menuItems() {
                if (this.getUserType() !== 'Counter') return this.items;
                const paginaPrincipal = this.items.find(item => item.title === 'Página Principal');
                const usuarios = this.items.find(item => item.title === 'Usuarios');
                if (!paginaPrincipal || !usuarios) return this.items;
                const counterUserSubItems = usuarios.sub_items.filter(
                    sub => sub.route === 'edit_user'
                );
                return [
                    paginaPrincipal,
                    {
                        ...usuarios,
                        section_title: 'Configuración',
                        header_color: '#12346b',
                        sub_items: counterUserSubItems
                    }
                ];
            }
        },
        watch: {
            $route (to, from){
                this.show = false;
                this.select_menu_item(to, from)
            }
        },
        beforeMount(){
            this.items = [
                {
                    title: 'Página Principal',
                    active: true,
                    component: 'home-icon',
                    dropdown: false,
                    selected: false,
                    route: 'main_menu_page',
                    sub_items:[]
                },
                {
                    title: 'Zonas/Puertas (Locaciones)',
                    section_title: 'Configuración',
                    header_color: '#12346b',
                    active: true,
                    component: 'location',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear Zona/Puerta',
                            route: 'location_new',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Editar Zona/Puerta (todos)',
                            route: 'location',
                            selected: false,
                            active: true
                        },
                        {
                            id: 3,
                            title: '*Crear apartamento "Pagos" (crear inmueble)',
                            route: 'location',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Roles de usuarios',
                    active: true,
                    component: 'user-roles-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear nuevo rol',
                            route: 'user_create_plan',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Lista de usuarios por rol',
                            route: '',
                            selected: false,
                            active: false
                        },
                        {
                            id: 3,
                            title: 'Editar roles de usuarios',
                            route: 'user_list_plans',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Usuarios',
                    component: 'user-icon',
                    active: true,
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Nuevo Usuario',
                            route: 'new_user',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Importar / actualizar usuarios',
                            route: 'import_users',
                            selected: false,
                            active: true
                        },
                        // {
                        //     id: 2,
                        //     title: 'Importar / actualizar empleados',
                        //     route: 'import_employees',
                        //     selected: false,
                        //     active: this.getCompany().has_booking_locations
                        // },
                        {
                            id: 3,
                            title: 'Ver todos',
                            route: 'users',
                            selected: false,
                            active: true
                        },
                        {
                            id: 4,
                            title: 'Ver activos',
                            route: 'users_active',
                            selected: false,
                            active: true
                        },
                        {
                            id: 5,
                            title: 'Editar información de usuario',
                            route: 'edit_user',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Noticias',
                    section_title: 'Servicios a residentes',
                    header_color: '#0D47A1',
                    active: true,
                    component: 'news',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear categoría de noticias',
                            route: 'special_categories',
                            selected: false,
                            active: this.getCompany().news.general_news
                        },
                        {
                            id: 2,
                            title: 'Noticias',
                            route: 'news',
                            selected: false,
                            active: this.getCompany().news.general_news
                        },
                        {
                            id: 3,
                            title: 'Videos',
                            route: 'news_video',
                            selected: false,
                            active: this.getCompany().news.video_news
                        },
                        {
                            id: 4,
                            title: 'Noticias Twit',
                            route: 'news_headline',
                            selected: false,
                            active: this.getCompany().news.twits_news
                        },
                        {
                            id: 4,
                            title: 'Lista de noticias públicas',
                            route: 'news_public',
                            selected: false,
                            active: this.getCompany().news.general_news
                        },
                        {
                            id: 4,
                            title: 'Lista de noticias inactivas',
                            route: 'news_hidden',
                            selected: false,
                            active: this.getCompany().news.general_news
                        },
                        {
                            id: 5,
                            title: 'Crear Banner',
                            route: 'banners_index',
                            selected: false,
                            active: true
                        },
                    ]
                },
                {
                    title: 'Mensajería',
                    active: true,
                    component: 'message-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Notificaciones push',
                            route: 'notification',
                            selected: false,
                            active: this.getCompany().notifications.push_notifications
                        },
                        {
                            id: 2,
                            title: 'Emails',
                            route: 'email_historial',
                            selected: false,
                            active: this.getCompany().messages.segment_mails
                        },
                        {
                            id: 3,
                            title: 'Whatsapp',
                            route: 'massive_whatsapp',
                            selected: false,
                            active: this.getCompany().messages.massive_messages
                        },
                        // {
                        //
                        // TODO: Check if needed
                        //     id: 4,
                        //     title: 'Plantillas',
                        //     route: 'whatsapp_templates',
                        //     selected: false,
                        //     active: this.getCompany().notifications.whatsapp_messages
                        // }
                    ]
                },
                {
                    title: 'Pagos',
                    active: this.getCompany().payments.admin_payments,
                    component: 'payments-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear apartamento',
                            route: 'location',
                            selected: false,
                            active: this.getCompany().payments.admin_payments
                        },
                        {
                            id: 2,
                            title: 'Revisar pagos',
                            route: 'configure_property',
                            selected: false,
                            active: this.getCompany().payments.admin_payments
                        },
                        {
                            id: 3,
                            title: 'Método de pago',
                            route: 'payment_methods',
                            selected: false,
                            active: this.getCompany().payments.admin_payments
                        },
                        {
                            id: 4,
                            title: 'Estado de Pago',
                            route: 'payments_status',
                            selected: false,
                            active: this.getCompany().payments.admin_payments
                        }
                    ]
                },
                {
                    title: 'Encuestas',
                    active: true,
                    component: 'form-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear encuesta',
                            route: 'new_form',
                            selected: false,
                            active: this.getCompany().forms.custom_forms
                        },
                        {
                            id: 2,
                            title: 'Resultados de encuestas',
                            route: 'forms_index',
                            selected: false,
                            active: this.getCompany().forms.custom_forms
                        }
                    ]
                },
                {
                    title: 'Catálogo Emprendimientos',
                    active: this.enabledItem(this.getCompany().offers),
                    component: 'offer',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear publicación',
                            route: 'offer_new',
                            selected: false,
                            active: this.enabledItem(this.getCompany().offers)
                        },
                        {
                            id: 2,
                            title: 'Publicaciones creadas',
                            route: 'offer',
                            selected: false,
                            active: this.enabledItem(this.getCompany().offers)
                        },
                        {
                            id: 3,
                            title: 'Publicaciones ocultas',
                            route: 'offer_hidden',
                            selected: false,
                            active: this.enabledItem(this.getCompany().offers)
                        },
                        {
                            id: 3,
                            title: 'Categorías de publicaciones',
                            route: 'category',
                            selected: false,
                            active: this.enabledItem(this.getCompany().offers)
                        },
                    ]
                },
                {
                    title: 'Fidelización',
                    active: this.getCompany().rewards.rewards,
                    component: 'reward',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Importar características',
                            route: 'new_segments_data',
                            selected: false,
                            active: this.getCompany().rewards.user_characteristics
                        },
                        {
                            id: 2,
                            title: 'Crear segmento',
                            route: 'condition',
                            selected: false,
                            active: this.getCompany().rewards.segments
                        },
                        {
                            id: 3,
                            title: 'Listado',
                            route: 'reward',
                            selected: false,
                            active: this.getCompany().rewards.rewards
                        },
                        {
                            id: 4,
                            title: 'Crear beneficio',
                            route: 'offer_new',
                            selected: false,
                            active: this.getCompany().rewards.rewards
                        },
                        // {
                        //     id: 5,
                        //     title: 'Geolocalización',
                        //     route: 'users_geolocations',
                        //     selected: false,
                        //     active: this.getCompany().rewards.rewards
                        // }
                    ]
                },
                {
                    title: 'Directorio',
                    active: false,
                    component: 'directory-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Comunidad',
                    active: false,
                    component: 'community-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Contactos',
                    active: false,
                    component: 'contact-us-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Paquetería',
                    active: this.getCompany().parcels.parcels_delivery,
                    component: 'parcels-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Gestionar paquetes',
                            route: 'parcels_index',
                            selected: false,
                            active: this.getCompany().parcels.parcels_delivery
                        }
                    ]
                },
                {
                    title: 'Accesos',
                    section_title: 'Seguridad',
                    header_color: '#1565C0',
                    active: this.enabledItem(this.getCompany().access),
                    component: 'access',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Mapa de calor',
                            route: 'dashboard_accesses',
                            selected: false,
                            active: this.getCompany().access.user_access
                        },
                        {
                            id: 2,
                            title: 'Por locación',
                            route: 'access',
                            selected: false,
                            active: this.getCompany().access.user_access
                        },
                        {
                            id: 3,
                            title: 'Crear recepcionista (Counter)',
                            route: 'counter_index',
                            selected: false,
                            active: this.getCompany().access.counter
                        },
                        {
                            id: 31,
                            title: 'Logs de acciones de Counter',
                            route: 'counter_logs',
                            selected: false,
                            active: this.getCompany().access.counter
                        },
                        {
                            id: 4,
                            title: 'Crear QR - Vigilante virtual',
                            route: 'virtual_guard_qr_generator',
                            selected: false,
                            active: this.getCompany().access.virtual_guard
                        },
                        {
                            id: 5,
                            title: 'Imprimir QR',
                            route: 'generate_qr',
                            selected: false,
                            active: this.getCompany().access.counter
                        },
                        {
                            id: 6,
                            title: 'Dispositivos de acceso por usuario',
                            route: 'access_devices',
                            selected: false,
                            active: true
                        },
                        {
                            id: 7,
                            title: 'Reestablecer dispositivo',
                            route: 'reset_user_devices',
                            selected: false,
                            active: true
                        },
                        {
                            id: 8,
                            title: 'Invitaciones',
                            route: 'invitations_index',
                            selected: false,
                            active: this.getCompany().invitations.admin_invitations
                        }
                    ]
                },
                {
                    title: 'Alertas',
                    active: true,
                    component: 'clientinformation',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Accesos por día',
                            route: 'alerts_index',
                            selected: false,
                            active: this.getCompany().access.alerts
                        },
                        {
                            id: 2,
                            title: 'Usuario con múltiples dispositivos',
                            route: 'alerts_device_index',
                            selected: false,
                            active: this.getCompany().access.alerts
                        }
                    ]
                },
                {
                    title: 'Reserva de espacios',
                    active: true,
                    component: 'spaces-reservation-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear reserva a un usuario',
                            route: 'booking_index',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Cancelar reserva',
                            route: 'cancel_booking',
                            selected: false,
                            active: true
                        },
                        {
                            id: 3,
                            title: 'Reportes',
                            route: 'reports',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Crear recepcionista',
                            route: 'counter_index',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Alarmas',
                    active: this.getCompany().alarms.alarms,
                    component: 'alarm-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Reportes',
                            route: 'AlarmsIndex',
                            selected: false,
                            active: this.getCompany().alarms.alarms
                        },

                    ]
                },
                {
                    title: 'Dispositivos',
                    active: this.getCompany().access.device_administration,
                    component: 'device-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear dispositivo',
                            route: 'new_device',
                            selected: false,
                            active: this.getCompany().access.device_administration
                        },
                        {
                            id: 2,
                            title: 'Listado de dispositivos',
                            route: 'devices',
                            selected: false,
                            active: this.getCompany().access.device_administration
                        },

                    ]
                },
                {
                    title: 'Invitaciones Empresariales',
                    active: this.getCompany().access.invitation_approved,
                    component: 'business-invitations-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Tipos de Invitaciones',
                            route: 'invitation_types',
                            selected: false,
                            active: this.getCompany().access.invitation_approved
                        },
                        {
                            id: 2,
                            title: 'Departamentos validadores',
                            route: 'approval_departments',
                            selected: false,
                            active: this.getCompany().access.invitation_approved
                        },
                        {
                            id: 3,
                            title: 'Usuarios validadores',
                            route: 'approved_users',
                            selected: false,
                            active: this.getCompany().access.invitation_approved
                        },
                        {
                            id: 4,
                            title: 'Criterios de aprovación',
                            route: 'departments_overiview',
                            selected: false,
                            active: this.getCompany().access.invitation_approved,
                        },


                    ]
                },
                {
                    title: 'Calendario de tareas',
                    section_title: 'Sistema de Gestión de Calidad',
                    header_color: '#1976D2',
                    active: this.getCompany().sgsst.general,
                    component: 'calendar-icon',
                    dropdown: this.getCompany().sgsst.general,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Ver calendario',
                            route: 'work_calendar',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Proveedores',
                    active: this.getCompany().sgsst.general,
                    component: 'providers-icon',
                    dropdown: this.getCompany().sgsst.general,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Crear proveedor',
                            route: 'providers',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Funcionarios',
                    active: false,
                    component: 'officials-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Censo',
                    active: false,
                    component: 'census-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Brigadistas',
                    active: false,
                    component: 'brigade-members-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Clasificación de residuos',
                    active: false,
                    component: 'waste-sorting-icon',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Usuarios',
                    section_title: 'Reportes',
                    header_color: '#1E88E5',
                    active: true,
                    component: 'user-icon',
                    dropdown: true,
                    selected: false,
                    sub_items:[
                        {
                            id: 1,
                            title: 'Usuarios registrados',
                            route: 'users',
                            selected: false,
                            active: true
                        },
                        {
                            id: 2,
                            title: 'Dashboard',
                            route: 'users_charts',
                            selected: false,
                            active: true
                        }
                    ]
                },
                {
                    title: 'Accesos',
                    active: true,
                    component: 'access',
                    dropdown: false,
                    selected: false,
                    route: 'reports',
                    sub_items:[]
                },
                {
                    title: 'Reserva de espacios',
                    active: true,
                    component: 'spaces-reservation-icon',
                    dropdown: false,
                    selected: false,
                    route: 'reports',
                    sub_items:[]
                },
                {
                    title: 'Beneficios',
                    active: false,
                    component: 'offer',
                    dropdown: false,
                    selected: false,
                    route: '',
                    sub_items:[]
                },
                {
                    title: 'Módulos',
                    section_title: 'Módulo de ayuda',
                    header_color: '#1976D2',
                    active: true,
                    component: 'user-roles-icon',
                    dropdown: false,
                    selected: false,
                    route: 'company_features',
                    sub_items: [],
                },
            ]
        },
        components: {
            user: user,
            offline,
            NavigationOption
        },
        methods:{
            getDisplayUserName() {
                const name = this.getNameUser ? String(this.getNameUser() || '').trim() : ''
                if (name) return name
                return this.getEmailUser ? String(this.getEmailUser() || '').trim() : ''
            },
            logout(){
                console.log('*******logout******')
                if(!window.eel){
                    window.location = '/';
                }else{
                    window.eel.close_program()
                    window.close();
                    window.location = '/';
                }
            },
            changeRoute(item, link){
                this.selected_item = item.title;
                this.selected_subitem = item.title;
                if (link === 'import_employees'){
                    this.items[3].sub_items[1].active = this.getCompany().has_booking_locations
                    item.active = this.getCompany().has_booking_locations
                }
                this.$router.push({name: item.active ? link : ''})
            },
            enabledItem(company_object){
                var visible = Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0 ? true : false
                return visible
            },
            select_menu_item(to, from){
                let previous_items = [];
                this.items.map(function(value, key) {
                    if (value.route && value.route.toString() === from.name.toString()){
                        previous_items.push(key)
                    }
                });
                let previous_sub_items = []
                this.items.map(function(value, item_key) {
                    let sub_items = []
                    value.sub_items.map(function(value, sub_item_key) {
                        if (value.route.toString() === from.name.toString()){
                            if (!previous_items.includes(item_key)){
                                previous_items.push(item_key)
                            }
                            sub_items.push(sub_item_key)
                        }
                    })
                    if (sub_items.length > 0){
                        sub_items.map(function(sub_item){
                            previous_sub_items.push({item_index: item_key, sub_item: sub_item})
                        })
                    }
                });
                previous_items = previous_items.filter(e => e !== -1)
                if(previous_items.length > 0 && previous_sub_items.length > 0){
                    previous_sub_items.forEach((subItem) => {
                        if (this.items[subItem.item_index].sub_items.length > 0){
                            this.items[subItem.item_index].selected = false
                            this.items[subItem.item_index].sub_items[subItem.sub_item].selected = false
                        }else{
                            this.items[subItem.item_index].selected = false
                        }
                    })
                }else if(previous_items.length > 0 && previous_sub_items.length === 0){
                    previous_items.forEach((index) => {
                        this.items[index].selected = false
                    })
                }

                let current_items = [];
                this.items.map(function(value, key) {
                    if (value.route && value.route.toString() === to.name.toString()){
                        current_items.push(key)
                    }
                });
                let current_sub_items = []
                this.items.map(function(value, item_key) {
                    let sub_items = []
                    value.sub_items.map(function(value, sub_item_key) {
                        if (value.route.toString() === to.name.toString()){
                            if (!current_items.includes(item_key)){
                                current_items.push(item_key)
                            }
                            sub_items.push(sub_item_key)
                        }
                    })
                    if (sub_items.length > 0){
                        sub_items.map(function(sub_item){
                            current_sub_items.push({item_index: item_key, current_sub_item: sub_item})
                        })
                    }
                });
                current_items = current_items.filter(e => e !== -1)
                if(current_items.length > 0 && current_sub_items.length > 0){
                    current_sub_items.forEach((subItem) => {
                        if (this.items[subItem.item_index].sub_items.length > 0){
                            this.items[subItem.item_index].selected = true
                            this.items[subItem.item_index].sub_items[subItem.current_sub_item].selected = true
                        }else{
                            this.items[subItem.item_index].selected = true
                        }
                    })
                }else if(current_items.length > 0 && current_sub_items.length === 0){
                    current_items.forEach((index) => {
                        this.items[index].selected = true
                    })
                }
            },
            enabledItem(company_object){
                var visible = Object.entries(company_object).filter(([key, value]) => value !== "" && value === true).length > 0 ? true : false
                return visible
            }
        },
        created(){
            console.log(' this.getCompany().',  this.getCompany() )
            console.log('***** this.getCompany().reward',  this.getCompany().rewards.rewards )
            console.log('***** this.getCompany().access.virtual_guard',   this.getCompany().access.virtual_guard )
        }
    }
</script>
<style>
    .drawer-expanded{
        min-width: 16.75% !important;
        margin-left: 1.5% !important;
        background: rgb(247, 247, 249) !important;
        padding-right: 0.5%;
        padding-bottom: 2%;
    }
    .drawer-close{
        min-width: 10.75% !important;
        margin-left: 0% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/NewNavigation.vue